import React from 'react';
import { withStyles } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import { ListHeaderWithFiltersStyles } from '../../../../components/ListHeaderWithFilters';

const CreateHeader = ({classes}) => {
  return (
    <div className={classes.wrapper}>
      <div className={classes.filters}>
        <Typography variant='h5' className={classes.header}>
          <div>Add Teammate</div>
        </Typography>
      </div>
      <p className={classes.subtitle}/>
    </div>
  )
}

export default withStyles(ListHeaderWithFiltersStyles)(CreateHeader)
